var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoggedUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3607_191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3607_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.6923C11.0347 11.6923 10.21 11.3503 9.526 10.6663C8.842 9.98242 8.5 9.15775 8.5 8.19225C8.5 7.22692 8.842 6.40225 9.526 5.71825C10.21 5.03425 11.0347 4.69225 12 4.69225C12.9653 4.69225 13.79 5.03425 14.474 5.71825C15.158 6.40225 15.5 7.22692 15.5 8.19225C15.5 9.15775 15.158 9.98242 14.474 10.6663C13.79 11.3503 12.9653 11.6923 12 11.6923ZM4.5 17.7885V17.0845C4.5 16.5948 4.633 16.1413 4.899 15.724C5.165 15.3067 5.5205 14.9858 5.9655 14.7615C6.95383 14.277 7.95092 13.9136 8.95675 13.6713C9.96258 13.4289 10.977 13.3078 12 13.3078C13.023 13.3078 14.0374 13.4289 15.0433 13.6713C16.0491 13.9136 17.0462 14.277 18.0345 14.7615C18.4795 14.9858 18.835 15.3067 19.101 15.724C19.367 16.1413 19.5 16.5948 19.5 17.0845V17.7885C19.5 18.2102 19.3523 18.5688 19.0568 18.8645C18.7613 19.16 18.4026 19.3078 17.9808 19.3078H6.01925C5.59742 19.3078 5.23875 19.16 4.94325 18.8645C4.64775 18.5688 4.5 18.2102 4.5 17.7885Z",
    fill: "#FAFAFA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoggedUser);
export default __webpack_public_path__ + "static/media/iconLoggedUser.e5bb643a19e881e7fbf8328b04bd2d79.svg";
export { ForwardRef as ReactComponent };